// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__2GSlP","content":"Consent_content__Xc2CR","footer":"Consent_footer__I6IQ_"};